import { StringObj } from '../types/StringObj'

export const EXPANDED_STATE_KEYS: StringObj = {
	MAIN: 'main',
	SOCIALS: 'socials',
}